import React, { useState, useEffect } from "react";

const AsignaturasForm = ({ onSave, editingAsignatura, onClear }) => {
  const [formData, setFormData] = useState({
    nombre: "",
    descripcion: "",
  });

  useEffect(() => {
    if (editingAsignatura) {
      setFormData({
        nombre: editingAsignatura.nombre || "",
        descripcion: editingAsignatura.descripcion || "",
      });
    } else {
      setFormData({ nombre: "", descripcion: "" });
    }
  }, [editingAsignatura]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.nombre.trim()) {
      alert("El nombre de la asignatura es requerido");
      return;
    }
    onSave(formData);
    setFormData({ nombre: "", descripcion: "" });
  };

  const handleCancel = () => {
    setFormData({ nombre: "", descripcion: "" });
    onClear();
  };

  return (
    <div className="bg-white p-6 rounded-2xl shadow-md mb-6">
      <h3 className="text-xl font-semibold mb-4">
        {editingAsignatura ? "Editar Asignatura" : "Crear Nueva Asignatura"}
      </h3>

      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Nombre de la Asignatura *
          </label>
          <input
            type="text"
            value={formData.nombre}
            onChange={(e) =>
              setFormData({ ...formData, nombre: e.target.value })
            }
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            placeholder="Ej: Matemáticas, Lengua Castellana..."
            required
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Descripción (Opcional)
          </label>
          <textarea
            value={formData.descripcion}
            onChange={(e) =>
              setFormData({ ...formData, descripcion: e.target.value })
            }
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            placeholder="Descripción breve de la asignatura..."
            rows="3"
          />
        </div>

        <div className="flex gap-3">
          <button
            type="submit"
            className="px-6 py-2 bg-blue-600 text-white rounded-lg font-semibold hover:bg-blue-700 transition-colors"
          >
            {editingAsignatura ? "Actualizar" : "Crear"} Asignatura
          </button>

          {editingAsignatura && (
            <button
              type="button"
              onClick={handleCancel}
              className="px-6 py-2 bg-gray-300 text-gray-700 rounded-lg font-semibold hover:bg-gray-400 transition-colors"
            >
              Cancelar
            </button>
          )}
        </div>
      </form>
    </div>
  );
};

export default AsignaturasForm;